import * as angularForms from "@angular/forms";
import * as angularFormsSignals from "@angular/forms/signals";
import * as angularFormsSignalsCompat from "@angular/forms/signals/compat";

// global glue variable for externals
if (window["ng"] == null) window["ng"] = <any>{};

window["ng"].forms = angularForms;
window["ng"].forms.signals = angularFormsSignals;
window["ng"].forms.signals.compat = angularFormsSignalsCompat;

export { angularForms, angularFormsSignals, angularFormsSignalsCompat };
